import {
  DateRangeDropdownV2,
  DateRangeDropdownV2 as DateRangeField,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  FormField,
  SearchField
} from '@/components/custom/erp';
import { accountSearchColumns, khachHangSearchColumns, nhanVienSearchColumns, QUERY_KEYS } from '@/constants';
import { SearchFieldActions, SearchFieldState } from '../../hooks';
import { type KhachHang, type NhanVien } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formState: {
    state: SearchFieldState;
    actions: SearchFieldActions;
  };
}

const BasicInfoTab = ({ formState: { state, actions } }: BasicInfoTabProps) => {
  return (
    <div className='p-4'>
      {/* Ngày c/từ (từ/đến) */}
      <div className='flex items-center gap-2'>
        <Label className='w-40 shrink-0'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          fromFieldClassName='w-48'
          toFieldClassName='w-48'
        />
      </div>

      {/* Số c/từ (từ/đến) */}
      <DocumentNumberRangeField label='Số c/từ (từ/đến)' fromName='so_ct1' toName='so_ct2' />

      <div className='flex items-center'>
        <Label className='w-40'>Giao dịch</Label>
        <div className='w-[210px]'>
          <FormField
            name='ma_gd'
            type='select'
            options={[
              { label: 'Tất cả', value: '' },
              { label: 'TL. Hàng bán trả lại', value: 'TL' }
            ]}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40'>Mã khách hàng</Label>
        <SearchField<KhachHang>
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          dialogTitle='Danh mục khách hàng'
          value={state.khachHang?.customer_code || ''}
          relatedFieldValue={state.khachHang?.customer_name || ''}
          onRowSelection={actions.setKhachHang}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40'>Mã nhân viên</Label>
        <SearchField<NhanVien>
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
          searchColumns={nhanVienSearchColumns}
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          dialogTitle='Danh mục khách hàng'
          value={state.nhanVien?.ma_nhan_vien || ''}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien || ''}
          onRowSelection={actions.setNhanVien}
        />
      </div>

      {/* Diễn giải */}
      <div className='flex items-center'>
        <Label className='w-40'>Diễn giải</Label>
        <div className='flex-1'>
          <FormField name='dien_giai' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
